import type { MutationHookOptions } from "@apollo/client"
import { useMutation } from "@apollo/client"
import upsertMutation from "@/v2-backoffice-client/layer/sublayer/layer.sublayer.upsert.mutation.gql"
import deleteMutation from "@/v2-backoffice-client/layer/sublayer/layer.sublayer.delete.mutation.gql"
import type {
  StudioSublayerUpsertMutation,
  StudioSublayerUpsertMutationVariables,
} from "@/v2-backoffice-client/layer/sublayer/__types__/layer.sublayer.upsert.mutation"
import type {
  StudioSublayerDeleteMutation,
  StudioSublayerDeleteMutationVariables,
} from "@/v2-backoffice-client/layer/sublayer/__types__/layer.sublayer.delete.mutation"
import { LAYER_SUBLAYER_QUERY_NAME } from "@/v2-backoffice-client/layer/sublayer/layer.sublayer.constants"

type UpsertOptions = MutationHookOptions<
  StudioSublayerUpsertMutation,
  StudioSublayerUpsertMutationVariables
>

/** Adds or edits one sublayer row under a catalog layer (dev environment). */
export function useLayerSublayerUpsertMutation(options?: UpsertOptions) {
  return useMutation<
    StudioSublayerUpsertMutation,
    StudioSublayerUpsertMutationVariables
  >(upsertMutation, {
    refetchQueries: [LAYER_SUBLAYER_QUERY_NAME],
    ...options,
  })
}

type DeleteOptions = MutationHookOptions<
  StudioSublayerDeleteMutation,
  StudioSublayerDeleteMutationVariables
>

/** Soft-deletes one sublayer row; the export carries it as IsEnabled false. */
export function useLayerSublayerDeleteMutation(options?: DeleteOptions) {
  return useMutation<
    StudioSublayerDeleteMutation,
    StudioSublayerDeleteMutationVariables
  >(deleteMutation, {
    refetchQueries: [LAYER_SUBLAYER_QUERY_NAME],
    ...options,
  })
}
